module.exports = __webpack_public_path__ + "img/nentwich_portrait_alt.78d66b31.jpg";